import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { PaymentNotifierService } from "src/app/public-website/buyer/components/buyer-info/container/buyer-info/PaymentNotifier.service";
import Swal from "sweetalert2";
import { CustomValidators } from "../../../../../shared/custom-validators";
import { BaseForm } from "../../../../../shared/product/baseForm";
import { ProductTypes } from "../../../../../shared/product/productTypes";
import { AuthService } from "../../../../../shared/services/auth.service";
import { FormValidatorService } from "../../../../../shared/services/form-validator.service";
import { Validators } from "../../../../../shared/validators";
import { PostProductStepService } from "../../services/post-product-step.service";

@Component({
  selector: 'app-quick-qassatly',
  templateUrl: './quick-qassatly.component.html',
  styleUrls: ['./quick-qassatly.component.scss']
})
export class QuickQassatlyComponent extends BaseForm implements OnInit {
  formValidator;
  stepForm!: FormGroup;
  qasatlyLimit: number;
  isSubmitting: boolean = false;
  productTypeId: any;
  isUpdate: any;
  get controllers(){
    return {
      Name: {
        fieldName: "Name",
        fieldNameAr: "الإسم",
        fieldType: "product_image",
        isStaticUI: true,
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.required,
            message: `${this.validationMsg.required}`,
            messageAr: `${this.validationMsgAr.required}`
          },
        ],
      },
      "Buyer Mobile Number": {
        fieldName: "Buyer Mobile Number",
        fieldNameAr: "رقم الهاتف للمشتري",
        fieldType: "product_image",
        isStaticUI: true,
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.required,
            message: `${this.validationMsg.required}`,
            messageAr: `${this.validationMsgAr.required}`
          },
          {
            validatorFn: CustomValidators.requiredNumber,
            message: `${this.validationMsg.requiredNumber}`,
            messageAr: `${this.validationMsgAr.requiredNumber}`
          },
        ],
      },
      "Buyer Email": {
        fieldName: "Buyer Email",
        fieldNameAr: "البريد الإليكتروني للمشتري",
        fieldType: "product_image",
        isStaticUI: true,
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.required,
            message: `${this.validationMsg.required}`,
            messageAr: `${this.validationMsgAr.required}`
          },
          {
            validatorFn: Validators.email,
            message: `${this.validationMsg.invalidEmail}`,
            messageAr: `${this.validationMsgAr.invalidEmail}`
          },
        ],
      },
      Amount: {
        fieldName: "Amount",
        fieldNameAr: "المبلغ",
        fieldType: "product_image",
        isStaticUI: true,
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.required,
            message: `${this.validationMsg.required}`,
            messageAr: `${this.validationMsgAr.required}`
          },
          {
            validatorFn: Validators.min(1),
            message: `${this.validationMsg.min}1`,
            messageAr: `${this.validationMsgAr.min}الـ1`
          },
          {
            validatorFn: Validators.max(this.qasatlyLimit),
            message: `${this.validationMsg.max}${this.qasatlyLimit}`,
            messageAr: `${this.validationMsgAr.max}الـ${this.qasatlyLimit}`
          },
          {
            validatorFn: CustomValidators.requiredNumber,
            message: `${this.validationMsg.requiredNumber}`,
            messageAr: `${this.validationMsgAr.requiredNumber}`
          },
        ],
      },
    };
  }

  constructor(
    private postStep: PostProductStepService,
    private router: Router,
    private authService: AuthService,
    private paymentNotifer:PaymentNotifierService
  ) {
    super();
    this.formValidator = new FormValidatorService();
  }

  async ngOnInit() {
    this.qasatlyLimit=await this.getQasatlyLimit();
    this.paymentNotifer.pushQassatlyNotification(true);
    if (!this.authService.hasQassatlyMerchantId()) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `You are not allowed to use this service, Please contact the Admin`
      });
      this.router.navigate(["/dashboard"]);
    }
    this.stepForm = this.formValidator.createForm(
      Object.values(this.controllers)
    );

    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
  }

  popupMsg(success: boolean, code?: string) {
    return Swal.fire({
      icon: success ? "success" : "error",
      title: success ? "Success" : "Oops...",
      text: success
        ? `Quick Qassatly Transaction Code is ${code}`
        : "Somthing went wrong. Please try again",
    });
  }

  async submit() {
    try {
      this.isSubmitting = true;
      let productValues = {
        Amount: this.stepForm.value.Amount,
        name: this.stepForm.value["Name"],
        email: this.stepForm.value["Buyer Email"],
        phone: this.stepForm.value["Buyer Mobile Number"],
        type: ProductTypes.quickQassatly,
        'Payment options': [{ id: 7, isSelected: true }],
      };
      productValues["Do you want the VAT to be on buyer?"] = !productValues["Do you want the VAT to be on buyer?"];
      this.postStep.setParams(productValues);
      let result = await this.postStep.make();
      if (result.success) {
        this.popupMsg(true, result.product.product.code);
        this.router.navigate(["/seller/products/management"]);
        this.isSubmitting = false;
      } else {
        this.popupMsg(false);
        this.isSubmitting = false;
      }
    } catch (error) {
      this.popupMsg(false);
      this.isSubmitting = false;
    }
  }

  convertControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }

  async getQasatlyLimit() {
    let Business =await this.authService.getBusiness();
    const QasatlyMerchant=Business.QassatlyMerchant;
    return Number(QasatlyMerchant.QasstlyLimit);
  }

}
